import { BaseRepository } from '@wephone-core/model/repository/base_repository';

export class AgentEventRepository extends BaseRepository {
  ENTITY_CLASS = AgentEventEntity;
  protected USE_PUSH_API = true;
}

import { AgentEventEntity } from '@wephone-core/model/entity/agent_event';
